import SaveRegistroFacturas from "../../components/save-registro-facturas/SaveRegistroFacturas";

export default function CreateregistroFacturas(){
  return<SaveRegistroFacturas titlePage={"Registro de Facturas"}/>
}